export default __webpack_public_path__ + "img/86d6181cec26f254b51f1716b242f7bd.svg";